import { ColorOptions, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../../components/AdminButton'
import { useNavigation } from '@react-navigation/core'
import { useStores } from '../../../../../data/store'

const AadharRedactionSubmit = ({ type, businessName, handleParentBack, applicationId }: any) => {
  const { resetPagination, resetSelectedDate, setSideMenuRefresh, accessConfig } = useStores((store) => ({
    createGroup: store.createEmsGroup,
    getCreateGroupData: store.onboarding.getCreateGroupData,
    createSubGroup: store.createSubGroup,
    getSubGroupData: store.onboarding.getSubGroupData,
    createEntity: store.createEntity,
    getEntityData: store.onboarding.getEntityData,
    resetCreateSingleEntitySelections: store.onboarding.resetCreateSingleEntitySelections,
    resetSelectionsDataOnSubmit: store.onboarding.resetSelectionsDataOnSubmit,
    resetPagination: store?.resetPagination,
    resetSelectedDate: store?.resetSelectedDate,
    setSideMenuRefresh: store.setSideMenuRefresh,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'ems_config']),
  }))
  const navigation = useNavigation()

  const getStatusTitle = () => {
    return "Changes are submitted and are pending for approval. \nYou can check further status from 'My Queue'"
  }

  const navigateToMyAppQueue = () => {
    resetSelectedDate()
    resetPagination()
    if (type === 'AD_MAKER') {
      navigation.reset({
        index: 0,
        routes: [{ name: 'aadharMakerQueue' }],
      })
    }
    // if (isAccessible(accessConfig, 'approve')) {
    //   navigation.navigate('checkerGlobalQueue')
    //   setSideMenuRefresh(true)
    // } else {
    //   navigation.navigate('makerMyQueue')
    //   setSideMenuRefresh(true)
    // }
  }

  const navigateToHome = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'aadharRedaction' }],
    })
  }

  return (
    <ModBox
      alignItems={'center'}
      justify={'center'}
      h={'100%'}
      minHeight={500}
      overflow={'auto'}
      testID="vertical-scroll">
      <ModBox
        justifyContent={'center'}
        alignItems={'center'}
        ph={80}
        pv={24}
        minWidth={552}
        h={'100%'}
        minHeight={'100%'}>
        <ModBox>
          <ModBox width={'100%'} alignItems={'center'} justifyContent={'center'}>
            <ModBox
              w={64}
              h={64}
              borderRadius={32}
              backgroundColor={'#FBEDD6' as ColorOptions}
              alignItems={'center'}
              justifyContent={'center'}>
              <Icon id={'STATUS_AWAITING'} color={'#E68E00' as ColorOptions} size={32} />
            </ModBox>
          </ModBox>
          <ModBox marginTop={32} alignItems={'center'} justifyContent={'center'}>
            <ModBox>
              <Text
                title={getStatusTitle()}
                color={'BLACK_21'}
                fontSize={16}
                fontFamily={'jiotype-bold'}
                textAlign={'center'}
              />
              <ModBox>
                <ModBox marginTop={32} alignItems={'center'} justifyContent={'center'}>
                  <ModBox alignItems={'center'} justifyContent={'center'}>
                    <Text title={'Application ID'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
                    <Text title={applicationId} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
                  </ModBox>
                  <ModBox marginTop={32} alignItems={'center'} justifyContent={'center'} show={false}>
                    <Text title={'Business Name'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
                    <Text title={businessName} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
                  </ModBox>
                </ModBox>
              </ModBox>
              <Spacer direction="vertical" size={40} />
              <ModBox direction="row" alignItems={'center'} justifyContent={'center'}>
                <ModBox show={true}>
                  <ButtonNew
                    height={40}
                    width={227}
                    type={'secondaryIcon'}
                    title={'Go to Aadhar Maker Queue'}
                    onPress={navigateToMyAppQueue}
                    borderColor={'#0070B6'}
                  />
                </ModBox>
                <Spacer direction="horizontal" size={16} />
                <ButtonNew
                  height={40}
                  width={227}
                  type={'secondaryIcon'}
                  title={'Go to home page'}
                  onPress={navigateToHome}
                  borderColor={'#0070B6'}
                />
              </ModBox>
            </ModBox>
          </ModBox>
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export default AadharRedactionSubmit
